var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBattleCards({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.49 3.067l-5.892-1.04A1.828 1.828 0 009.483 3.51l-.14.795c-.07.01-.14.024-.21.043L3.355 5.895a1.814 1.814 0 00-1.109.851 1.814 1.814 0 00-.182 1.386l2.55 9.514c.125.47.428.865.85 1.108a1.815 1.815 0 001.386.183l5.78-1.549a1.814 1.814 0 001.277-1.243l1.24.218a1.823 1.823 0 002.116-1.48l1.71-9.7a1.828 1.828 0 00-1.481-2.116zM12.959 15.41a.825.825 0 01-.083.63.824.824 0 01-.504.386l-5.78 1.549a.824.824 0 01-.63-.083.824.824 0 01-.387-.504L3.025 7.874a.825.825 0 01.083-.63c.11-.192.29-.33.504-.386l5.78-1.55a.835.835 0 01.63.084c.192.11.329.29.386.504l2.55 9.514zm-.998-7.572c.004-.028.007-.057.012-.085a.63.63 0 011.22-.079.498.498 0 00.87.153.628.628 0 011.119.492c-.198 1.123-1.464 2.08-2.094 2.492a7.984 7.984 0 01-.562-.863l-.565-2.11zm6.031-2.829l-1.71 9.7a.831.831 0 01-.962.674l-1.404-.248-.852-3.18c.05-.01.1-.027.147-.052.106-.058 2.604-1.44 2.952-3.411a1.627 1.627 0 00-2.363-1.718 1.62 1.62 0 00-.925-.512 1.614 1.614 0 00-1.214.27l-.042.03-.248-.924a1.814 1.814 0 00-1.04-1.203l.134-.753a.83.83 0 01.961-.673l5.893 1.039c.45.08.753.51.673.961z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.428 14.873a.498.498 0 00.8-.215l1.138-3.367a.498.498 0 00-.143-.533L7.555 8.411a.498.498 0 00-.8.215l-1.138 3.366c-.064.19-.008.4.143.534l2.668 2.347zm-.97-5.22l1.858 1.634-.792 2.344-1.857-1.634.792-2.344z"
  })));
}

export default SvgBattleCards;